<template>
  <iframe
    ref="frame"
    class="chatwoot-teste-frame"
    :src="url"
    title="Conversa de teste do fluxo"
    @load="enviarConfiguracao"
    @error="falharCarregamento"
  />
</template>

<script>
export default {
  props: {
    contaId: { type: [Number, String], required: true },
    fluxoId: { type: [Number, String], required: true }
  },
  data() {
    return { url: `${process.env.BASE_URL}fluxo-chatwoot-teste.html` };
  },
  mounted() {
    window.addEventListener("message", this.receberMensagem);
    this._timeoutTeste = setTimeout(() => {
      this.$emit(
        "error",
        new Error(
          "A conversa de teste demorou para responder. Tente novamente."
        )
      );
    }, 30000);
  },
  beforeDestroy() {
    clearTimeout(this._timeoutTeste);
    window.removeEventListener("message", this.receberMensagem);
  },
  methods: {
    falharCarregamento() {
      clearTimeout(this._timeoutTeste);
      this.$emit(
        "error",
        new Error("Não foi possível carregar a conversa de teste.")
      );
    },
    enviarConfiguracao() {
      this.$refs.frame?.contentWindow?.postMessage(
        {
          type: "fluxo-teste:iniciar",
          conta_id: this.contaId,
          fluxo_id: this.fluxoId
        },
        window.location.origin
      );
    },
    receberMensagem(event) {
      if (
        event.origin !== window.location.origin ||
        event.source !== this.$refs.frame?.contentWindow
      )
        return;
      if (event.data?.type === "fluxo-teste:carregado")
        this.enviarConfiguracao();
      if (event.data?.type === "fluxo-teste:pronto") {
        clearTimeout(this._timeoutTeste);
        this.$emit("ready");
      }
      if (event.data?.type === "fluxo-teste:fechado") this.$emit("close");
      if (event.data?.type === "fluxo-teste:erro") {
        clearTimeout(this._timeoutTeste);
        this.$emit(
          "error",
          new Error(
            event.data.message || "O Chatwoot não respondeu. Tente novamente."
          )
        );
      }
    }
  }
};
</script>

<style scoped>
.chatwoot-teste-frame {
  border: 0;
  display: block;
  flex: 1;
  height: 100%;
  min-height: 0;
  width: 100%;
}
</style>
